import { isUndefined } from 'lodash';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { alphabetGenerator } from 'utilities';
import { DividendRateParser, ReverseParsedDividendRateLedgerItem } from './types';

const parser: DividendRateParser = params => {
  const { columns, rowConfig } = params;
  const alphabet = alphabetGenerator([], columns.length);
  const cells = {} as { [key: string]: ICell };
  columns.forEach((column, colIndex) => {
    const columnKey = alphabet[colIndex];
    rowConfig.forEach((row, rowIndex) => {
      const rowNumber = rowIndex + 1;
      const cellKey = `${columnKey}${rowNumber}`;
      const value = !isUndefined(column[row.alias as keyof ReverseParsedDividendRateLedgerItem])
        ? column[row.alias as keyof ReverseParsedDividendRateLedgerItem]
        : null;
      const newValue = row.dbType === 'boolean' ? Number(value) : value;
      cells[cellKey] = {
        ...row,
        value: newValue as ICell['value'],
        key: cellKey,
        alias: row.alias,
        columnLegend: columnKey,
      };
    });
  });
  return cells;
};

export default parser;
